<template>
  <div>
    <div class="header--sm mb-2" v-html="title" />
    <description-list v-if="list" :list="list" />
    <slot />
  </div>
</template>

<script>
import DescriptionList from '@/components/DescriptionList';
export default {
  name: 'ProjectOneToolbarTabLayout',
  components: {
    DescriptionList,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    list: {
      type: Array,
      default: undefined,
    },
  },
};
</script>
